import React from "react";
import ToolTip from "../../../parts/tooltip";
import SvgIcon from "../../../parts/SvgIcon";
import { getUserToRequest } from "./manage-coaches/utils/manage-coaches-utils";
import { renderToStaticMarkup } from "react-dom/server";
import { PushCommunityCardActionsComponent } from "./push-preferences/PushCommunityCardActionsComponent";

const placeholders = {
  global: `
  <script src="https://yourcdn.script.com/script.js"></script>
  <script>scriptFunction(new Date());</script>`,
  paymentSuccess: ` 
  gtag("event", "conversion", {
    send_to: "AW-YYYYY/XXXXX",
    unit_amount: %PRICE%,
    interval: %INTERVAL%,
    email: %EMAIL%,
  });`,
};
const PushPreferences = ({ locals, userToSendInformation }) => {
  const { activeUser, organizationOwner } = locals;
  const userToRequest = getUserToRequest(activeUser, organizationOwner);
  const { customBranding = {}, pushAccountInfo = {} } = userToRequest;
  const { communityLink = "" } = customBranding;
  const initialState = {
    global: customBranding?.storefrontSnippets?.global
      ? customBranding.storefrontSnippets.global
      : "",
    paymentSuccess: customBranding?.storefrontSnippets?.paymentSuccess
      ? customBranding.storefrontSnippets.paymentSuccess
      : "",
  };

  const [state, setState] = React.useState(initialState);

  const handleChange = ({ target }) => {
    setState({
      ...state,
      [target.name]: target.value,
    });
  };

  const renderGlobalTooltip = () => {
    return (
      <ToolTip
        id="global-tooltip"
        body={["Main snippet executed in the <head> section of the storefront"]}
      >
        <SvgIcon className="help-icon" src="/img/svg/question-circle.svg" />
      </ToolTip>
    );
  };

  const renderPaymentTooltip = () => {
    return (
      <ToolTip
        id="payment-tooltip"
        html={renderToStaticMarkup(
          <div className="paymentSucess-tooltip">
            <p>
              Snippet executed when a payment is successful, this is on plain
              Javascript
            </p>
            <p> Example using Google Tag Manager:</p>
            <p>{`gtag("event", "conversion", {`}</p>
            <p>send_to: "AW-YYYYYY/XXXXX",</p>
            <p>
              unit_amount: <span style={{ color: "green" }}>%PRICE%</span>,{" "}
            </p>
            <p>
              interval: <span style={{ color: "green" }}>%INTERVAL%</span>,{" "}
            </p>
            <p>
              email: <span style={{ color: "green" }}>%EMAIL%</span>,
            </p>
            <p>{`});`}</p>
            <p>
              <span style={{ color: "green" }}>Green: Placeholder</span>
            </p>
          </div>
        )}
      >
        <SvgIcon className="help-icon" src="/img/svg/question-circle.svg" />
      </ToolTip>
    );
  };

  return (
    <form
      id="form-push"
      method="POST"
      encType="multipart/form-data"
      data-noreset
      className="push"
    >
      <input
        type="hidden"
        name="userToSendInformation"
        defaultValue={userToSendInformation}
      />
      <div className="push-community">
        <div className="push-community-card">
          <div className="push-community-card-info">
            <span>In-App Community</span>
          </div>
          <PushCommunityCardActionsComponent
            pushAccountInfo={pushAccountInfo}
            useLink={false}
            option="inAppCommunityEnabled"
            tooltip="This in-app chat system allows you to create dedicated channels where your subscribers can engage in real-time conversations. Easily manage topics, facilitate discussions, and foster a sense of community among your users."
          />
        </div>
        <div className="push-community-card">
          <div className="push-community-card-info">
            <span>External Community</span>
          </div>
          <PushCommunityCardActionsComponent
            pushAccountInfo={pushAccountInfo}
            communityLinkFromDb={communityLink}
            useLink={true}
            option="externalCommunityEnabled"
            tooltip="Link an external community for your subscribers to chat (e.g. discord, Facebook group, circle, etc)"
          />
        </div>
      </div>
      <h4 className="mb-3">Storefront Integrations</h4>
      <p className="p2">
        In this section you’ll be able to setup integrations with external
        services such Facebook Pixel, Google Tag Manager, Rewardfull, etc…
      </p>
      <p className="p2 mb-12">
        Please contact{" "}
        <span className="text-[--information]">info@mystrengthbook.com </span>{" "}
        before adding anything to this section of the app.
      </p>
      <h4 className="mb-6">Snippets</h4>
      <label>
        Global Site Snippet
        {renderGlobalTooltip()}
      </label>
      <textarea
        name="global"
        className="textarea-input min-h-[12rem] mb-8"
        placeholder={placeholders.global}
        value={state.global}
        onChange={handleChange}
      />
      <label>
        Payment Success Snippet
        {renderPaymentTooltip()}
      </label>
      <textarea
        name="paymentSuccess"
        className="textarea-input min-h-[12rem]"
        placeholder={placeholders.paymentSuccess}
        value={state.paymentSuccess}
        onChange={handleChange}
      />
      <div className="only-show-mobile" role="separator-line" />
      <label className="mt-16 mobile-hidden">Placeholders:</label>
      <p className="chip info mb-2">
        %PRICE% - This is the price of the plan that the customer paid, it comes
        in the form of a number, e.g. $39,99 = 3999{" "}
      </p>{" "}
      <p className="chip info mb-2">
        %INTERVAL% - This is the interval of the plan that the customer paid, it
        comes in the form of a string (month or year){" "}
      </p>{" "}
      <p className="chip info mb-2">
        %EMAIL% - This is the email of the customer, it comes in the form of a
        string{" "}
      </p>{" "}
      <p className="p4 mb-6">
        Used for matching events and values from our platform and send it to
        your external services.
      </p>
      <p>
        <span className="chip warning">
          Warning: Adding a script can cause the site performance of the
          strorefront to be compromised. MyStrengthBook reserves the right to
          remove the scripts at anytime, if necessary.
        </span>
      </p>
    </form>
  );
};
export default PushPreferences;
